import { useMemo } from 'react';

import type { WithSlotProps } from '~/components/hocs';
import { withSlot } from '~/components/hocs';
import { renderChild } from '~/components/layout/utils';
import { SlotsProvider } from '~/components/providers';
import { useTemplate } from '~/hooks';
import { selectCommentThread, useStore } from '~/store';
import { CommentThread } from '../comment-thread';

export const NAME = 'Comment';

export interface Props extends React.PropsWithChildren, WithSlotProps {
  commentId: string;
  className?: string;
}

const CommentComponent = (props: Props) => {
  const commentThread = useStore(state => selectCommentThread(state, props.commentId));
  const template = useTemplate(NAME);
  const slots = useMemo(
    () => ({
      threads: {
        children: commentThread ? (
          <CommentThread commentId={commentThread.id} isLast={!commentThread.replies.length} />
        ) : null,
      },
    }),
    [commentThread]
  );

  return <SlotsProvider slots={slots}>{renderChild(template)}</SlotsProvider>;
};

CommentComponent.displayName = NAME;

export const Comment = withSlot(CommentComponent);
